import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { BrainCircuit } from "lucide-react";

export const JarvisBrainCard = () => {
  const [model, setModel] = useState(null);
  useEffect(() => {
    let active = true;
    api.get("/jarvis/brain")
      .then(({ data }) => { if (active) setModel(data.claude_model); })
      .catch(() => { if (active) setModel(null); });
    return () => { active = false; };
  }, []);
  return (
    <div className="card-soft p-4 mt-3" data-testid="jarvis-brain-card">
      <div className="flex items-center gap-2 mb-2">
        <BrainCircuit size={18} className="text-[color:var(--jarvis)]" />
        <p className="text-sm font-medium">Edit använder Claude</p>
      </div>
      <p className="text-[11px] text-[color:var(--text-tertiary)] leading-tight">
        Anpassar svaren efter samtalet och kan söka på webben vid behov.
      </p>
      {model && <p className="text-xs mt-2">{model}</p>}
    </div>
  );
};
